var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"19b9fe6a7c4346bdbca7ccc654585a608a916700"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clhbidcom@clhbid"]={id:"19b9fe6a7c4346bdbca7ccc654585a608a916700"};
      